'use strict';

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.jQuery = $;

// require('./lib/viewport'); // Voeg een class toe als element in beeld is (optioneel).

require('foundation-sites');
require('lazyload');
require('fullpage.js');
require('bxslider/dist/jquery.bxslider.min.js');
//require('mmenu-js');
require('@fancyapps/fancybox');
//require('slick-carousel');

var raadhuis = require('./lib/default'); // Standaard JS functions (Slick slider, mmenu, sticky nav etc.).

// If you want to pick and choose which modules to include, comment out the above and uncomment the line below, go to the file and comment :
// import './lib/foundation-explicit-pieces';



$(document).ready(function () {

  // HEADER

  $('.read-more, .read-more-mobile').click(function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $(window).height()
    }, 500);
  });

  // FAQ

  $('.faq .faq-answer').hide();
  $('.faq-question').click(function () {
    $(this).toggleClass('active');
    $(this).next('.faq-answer').slideToggle();
  });


  $('.gallery-block a').fancybox({
  });

  // VALIDATION


  // ANIMATION

  if ($(document).scrollTop() === 0) {
    $('.loading').fadeOut(500, function () {
      $(this).css('background', 'none');
    });
    $('body').addClass('anm-start');

    setTimeout(function () {
      if ($('body').hasClass('frontpage')) {
        $('body').addClass('anm-1');
      } else {
        $('body').addClass('anm-2');
      }

    }, 200);

    setTimeout(function () {
      $('body').removeClass('anm-start');
    }, 300);

    setTimeout(function () {
      $('body').removeClass('anm-1 anm-2');
    }, 4000);
  } else {
    $('body').addClass('no-intro');
    setTimeout(function () {
      $('body').removeClass('no-intro');
    }, 1000);
    $('.loading').fadeOut(500, function () {
      $(this).css('background', 'none');
    });
  }

  setTimeout(function () {
    $('body').removeClass('anm-start');
  }, 300);



  // MENU

  $('#index-btn').click(function (e) {
    e.preventDefault();
    $('body').removeClass('search-open login-open');
    $('body').toggleClass('menu-open');
    if ($('body').hasClass('menu-open')) {
      $('#menu .menu-inner, .menu-background').height($('#menu .menu-inner ul').outerHeight() + 80);
    } else {
      $('#menu .menu-inner, .menu-background').height(0);
    }
  });

  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top + 0
    }, 1000);
  });


  $('.login').click(function (e) {
    e.preventDefault();
    $('body').removeClass('search-open menu-open');
    $('body').toggleClass('login-open');
    if ($('body').hasClass('login-open')) {
      $('#menu-intern .menu-inner, .menu-background').height($('#menu-intern .menu-inner ul').outerHeight());
    } else {
      $('#menu-intern .menu-inner, .menu-background').height(0);
    }
    $('#menu-close').click(function (e) {
      e.preventDefault();
      $('body').removeClass('menu-open login-open');
      $('#menu-intern .menu-inner, .menu-background').height(0);
    });
  });

  $('.menu-close').click(function (e) {
    e.preventDefault();
    $('body').removeClass('menu-open login-open');
    $('#menu .menu-inner, #menu-intern .menu-inner, .menu-background').height(0);
  });

  $('#search-btn').click(function (e) {
    e.preventDefault();
    $('body').removeClass('menu-open login-open');
    $('body').toggleClass('search-open');
    if ($('body').hasClass('search-open')) {
      $('.menu-background').css('height', '100%');
    } else {
      $('.menu-background').css('height', '0').height(0);
    }
  });

  $('#menu ul li.main').each(function (e) {
    $(this).has('ul').addClass('with-submenu').append('<div class="submenu-arrow"></div>');
  });

  function menuMobile() {
    if ($(window).width() < 767) {
      $('#menu ul li.with-submenu').unbind('mouseenter mouseleave');
      $('#menu ul li.with-submenu .submenu-arrow').click(function () {
        if ($(this).parent('.with-submenu').hasClass('active')) {
          $('#menu ul li.with-submenu').removeClass('active');
          $('#menu .menu-inner, .menu-background').height($('#menu .menu-inner ul').outerHeight());
          $('.sub-menu').hide();
        } else {
          $('#menu ul li.with-submenu').removeClass('active');
          $('#menu .menu-inner, .menu-background').height($('#menu .menu-inner ul').outerHeight() + 240);
          $('.sub-menu').hide();
          $(this).parent('.with-submenu').addClass('active');
          $(this).parent('.with-submenu').find('.sub-menu').show();
        }
      });
    } else {
      $('.sub-menu').attr('style', '');
      $('#menu ul li.with-submenu').hover(function () {
        $(this).addClass('active');
      }, function () {
        $(this).removeClass('active');
      });
    }
  }

  function Border() {
    if ($(window).scrollTop() > 0) {
      $('header').addClass('no-border');
    } else {
      $('header').removeClass('no-border');
    }
  }

  // PROJECTS
  //filter op project master
  $('.prj-filter').click(function (e) {
    e.preventDefault();
    var richting = $(this).attr('data-projectsoort');
    $('.project[data-projectsoort="' + richting + '"]').show();
    $('.project[data-projectsoort!="' + richting + '"]').hide();

    $('.projects').masonry({
      // options
      itemSelector: '.project',
      columnWidth: '.project-size',
      gutter: 0
    });

  });
//$('.projects').masonry({
    //options
  //  itemSelector: '.project',
    //columnWidth: '.project-size',
  //  gutter: 0
 // });

  // NAV
  $('.nav-filter').click(function (e) {
    e.preventDefault();
    var target = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(target).offset().top
    }, 500);
  });

  // ANIMATIE

  function revealBlock() {
    var scrollTop = $(document).scrollTop();
    $('.project').each(function (e) {
      if ($(window).width() > 767) {
        if ($(this).offset().top < (scrollTop + $(window).height() - 250)) {
          $(this).addClass('show');
          if ($(this).attr('data-image')) {
            var image = $(this).attr('data-image');
            $(this).find('.project-padding').css('background', 'url(' + image + ')');
          }
        }
      } else if ($(window).width() < 768) {
        if (($(this).offset().top) < (scrollTop + $(window).height())) {
          $(this).addClass('show');
          if ($(this).attr('data-image')) {
            var image = $(this).attr('data-image');
            $(this).find('.project-padding').css('background', 'url(' + image + ')');
          }
        }
      }
    });
  }

  // AGENDA

  $('.agenda-slider').bxSlider({
    slideSelector: $('.agenda-slider .project'),
    slideWidth: 400,
    infiniteLoop: false,
    minSlides: 1,
    maxSlides: 3,
    pager: false,
    moveSlides: 1,
    touchEnabled: false,
    hideControlOnEnd: true,
    onSlideBefore: function (currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
      $('.agenda-slider .project.active').removeClass('active');
      $('.agenda-slider > .project').eq(currentSlideHtmlObject + 0).addClass('active');
      $('.agenda-slider > .project').eq(currentSlideHtmlObject + 1).addClass('active');
      $('.agenda-slider > .project').eq(currentSlideHtmlObject + 2).addClass('active');

    },
    onSliderLoad: function () {
      $('.agenda-slider > .project').eq(0).addClass('active');
      $('.agenda-slider > .project').eq(1).addClass('active');
      $('.agenda-slider > .project').eq(2).addClass('active');
    }
  });

  // SEARCH

  $('.sisea-search-form').submit(function () { //Handle submission
    return false; //More "don't fire" insurance
  });

  $('.sisea-search-form input').keyup(function () { //Live search functionality
    if (this.value.length > 2) { //User types more than 2 characters in our search field
      $('#site-search-results').load('/search-result', $('.sisea-search-form').serialize()).show(); //Load search results from our landing resource and show the container
    } else {
      $('#site-search-results').hide(); //If not more than 2 characters typed, make sure the results container is hidden (CSS display:none;)
    }
  });

  $(document).on('click', '.sisea-page a', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $('#site-search-results').load(href).show(); //Load search results from anchor element
  });

  // PANELS

  $(".panel-link").mouseenter(function () {
      var panel = $(this).data('id');
      $('.panel').addClass('panel-open');
      $('.panel#' + panel + '').addClass('active').removeClass('panel-open');
    })
    .mouseleave(function () {
      var panel = $(this).data('id');
      $('.panel').removeClass('panel-open');
      $('.panel#' + panel + '').removeClass('active');
    });


  // PROJECT

  $('.project-slider').bxSlider({
    slideSelector: $('.project-slider .project'),
    slideWidth: 600,
    infiniteLoop: false,
    minSlides: 1,
    maxSlides: 2,
    pager: false,
    moveSlides: 1,
    touchEnabled: false,
    hideControlOnEnd: true,
    onSlideBefore: function (currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
      $('.project-slider .project.active').removeClass('active');
      $('.project-slider >.project').eq(currentSlideHtmlObject + 0).addClass('active');
      $('.project-slider >.project').eq(currentSlideHtmlObject + 1).addClass('active');

    },
    onSliderLoad: function () {
      $('.project-slider >.project').eq(0).addClass('active');
      $('.project-slider >.project').eq(1).addClass('active');
    }
  });

  $(window).scroll(function (e) {
    Border();
    revealBlock();
  });

  $(window).resize(function (e) {
    menuMobile();
  });

  menuMobile();
  Border();
  revealBlock();
});

$(document).foundation();